import {
  ResourceBar,
  type ResourceBarProps,
} from "@thilke/ui/components/resource-bar";

function HealthBar(props: ResourceBarProps) {
  return <ResourceBar {...props} indicatorClassName="bg-destructive" />;
}

export default HealthBar;
export { HealthBar };
